import { AccessControlInputType } from '../../../infra/startup/types';
import { AccessControlInterface } from './AccessControlInterface';
import { AccessControlInterfaceType } from './types';

let accessControlInterface: AccessControlInterface;

export function getAccessControlInterface(): AccessControlInterface {
  return accessControlInterface;
}

/**
 * Initialize the AccessControl interface
 *
 * @param options - Configuration for AccessControl
 * @returns AccessControl interface object
 */
export default async function initializeAccessControlInterface({
  accessControl
}: {
  accessControl: AccessControlInputType;
}): Promise<AccessControlInterfaceType> {
  if (accessControlInterface) return accessControlInterface.getInterface();

  // Create an instance of the new AccessControlInterface class
  accessControlInterface = new AccessControlInterface(accessControl);

  // Return the interface methods
  return accessControlInterface.getInterface();
}
